import React from 'react'
import { Pressable, Text } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { baseFont } from '../../utils/ui'

export function PrimaryButton({
  label,
  onPress,
  rounded = false,
  accent = false,
}: {
  label: string
  onPress: () => void
  rounded?: boolean
  accent?: boolean
}) {
  const { theme } = useThemeValue()

  return (
    <Pressable
      onPress={onPress}
      style={{
        paddingHorizontal: 24,
        paddingVertical: 14,
        borderRadius: rounded ? 999 : theme.radii.l,
        backgroundColor: accent ? theme.colors.primary : theme.colors.text,
      }}
    >
      <Text
        style={{
          ...baseFont('700'),
          color: theme.colors.textReversed,
          fontSize: 13,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          textAlign: 'center',
        }}
      >
        {label}
      </Text>
    </Pressable>
  )
}
